module.exports = __webpack_public_path__ + "img/sample-mini-02.543d2bc3.jpg";